import script from "./liveContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./liveContent.vue?vue&type=script&lang=ts&setup=true"

import "./liveContent.vue?vue&type=style&index=0&id=a6bd5206&lang=less"
import "./liveContent.vue?vue&type=style&index=1&id=a6bd5206&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6bd5206"]])

export default __exports__